import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Text, Box, Flex, Button, VectorRightIcon, useMatchBreakpoints } from 'uikit'
import { useTranslation } from 'contexts/Localization'

const Model = styled.img`
  width: 280px;

  ${({ theme }) => theme.mediaQueries.md} {
    width: 350px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    width: 550px;
  }
`

const PurpleTitle = styled(Text)`
  font-size: 20px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 25px;
  }
`

const Title = styled(Text)`
  font-size: 20px;

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 28px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 30px;
  }
`

const Detail = styled(Text)`
  font-size: 14px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 16px;
  }
`

const Quality: React.FC = () => {
  const { t } = useTranslation()
  const { isXs, is2sm, isMd, isLg } = useMatchBreakpoints()

  return (
    <Flex
      mt={['50px', null, null, null, '80px']}
      justifyContent="space-between"
      mx="auto"
      alignItems="center"
      maxWidth="1240px"
      flexDirection={['column', null, null, null, null, 'row']}
    >
      {(isXs || is2sm || isMd || isLg) && <Model src="/images/home/nft-model.png" alt="nft-model" />}
      <Box>
        <PurpleTitle color="primary" fontWeight="600">
          {t('NFTs')}
        </PurpleTitle>
        <Title fontWeight="600" maxWidth={['100%', null, null, null, null, '350px']}>
          {t('Mint and Stake your NFTs to earn DMD')}
        </Title>
        <Detail
          mt={['10px', null, '15px', null, '18px']}
          fontWeight="300"
          color="textSecondary"
          maxWidth={['100%', null, null, null, null, '500px']}
        >
          {t(
            'Bringing utility to the NFT space on Fantom Opera Network. Users stake digital collectibles and earn $DMD. We proudly introduce our Weighted Staking feature, allowing NFTs to earn at different rates!',
          )}
        </Detail>
        <Button
          as={Link}
          to="/nft/series"
          height="27px"
          mt={['30px', null, '40px', null, '60px']}
          variant="text"
          p="0"
          endIcon={<VectorRightIcon fill="#128DFF" />}
        >
          <Text fontSize="18px" fontWeight="500" color="#128DFF">
            {t('Mint NFTs Now')}
          </Text>
        </Button>
      </Box>
      {!(isXs || is2sm || isMd || isLg) && <Model src="/images/home/nft-model.png" alt="nft-model" />}
    </Flex>
  )
}

export default Quality
